import { render, staticRenderFns } from "./PlayerLoader.vue?vue&type=template&id=2c042974&scoped=true"
import script from "./PlayerLoader.vue?vue&type=script&lang=ts"
export * from "./PlayerLoader.vue?vue&type=script&lang=ts"
import style0 from "./PlayerLoader.vue?vue&type=style&index=0&id=2c042974&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c042974",
  null
  
)

export default component.exports